import { useEffect, useState } from 'react'
import { Field } from 'react-final-form'
import { FieldArray } from 'react-final-form-arrays'
import { checkInvitingUsers } from '../../../api/userCompany'
import {
  PrimaryButton,
  SecondaryButton,
} from '../../../components/UI/Buttons/Button'
import RoleSelect from '../../../components/User/RoleSelect'
import { trans } from '../../../utils/utilsTrans'

const AddingUserForm = ({
  userEmail,
  values,
  currentRole,
  setCurrentRole,
  blackListRoles,
  selectedCompany,
}) => {
  const [email, setEmail] = useState(userEmail || '')
  const [error, setError] = useState(null)
  const [isEmailValide, setIsEmailValide] = useState(false)

  useEffect(() => {
    if (validateEmail(email)) {
      setIsEmailValide(true)
    } else {
      setIsEmailValide(false)
    }
  }, [email])

  const validateEmail = (email) => {
    return email.match(
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    )
  }

  const addUser = (fields) => {
    if (values.invitations?.some((v) => v.email === email)) {
      setError('users.invitations.already_entered_email')
    } else {
      const body = {
        invitations: [{ email, role: currentRole }],
      }

      checkInvitingUsers(selectedCompany, body)
        .then((res) => {
          fields.push({
            email,
            role: currentRole,
            wrong_status: res[email].includes('wrong_status'),
            cant_invite: res[email].includes('cant_invite'),
          })
          setEmail('')
        })
        .catch((err) => console.error(err))
    }
  }

  return (
    <FieldArray name='invitations'>
      {({ fields }) => (
        <div className='min-h-0 flex flex-col w-full'>
          <div className='flex justify-between items-center'>
            <div className='relative box-content flex justify-between py-8 px-14 rounded-8 border border-greyLight7 bg-backgroundPrimary w-9/12'>
              <input
                disabled={!!userEmail}
                value={email}
                onChange={(e) => {
                  setError(null)
                  setEmail(e.target.value)
                }}
                placeholder={trans('email')}
                className='flex-initial max-w-[200px] bg-transparent placeholder:text-greyLight3 text-sm text-greyLight1 outline-none'
              />
              <RoleSelect
                blackListRoles={blackListRoles}
                currentRole={currentRole}
                hasDelete={false}
                enableChangeRole={blackListRoles.length < 2}
                setCurrentRole={setCurrentRole}
              />
            </div>
            {!userEmail ? (
              <PrimaryButton
                extraClass='w-2/12'
                text={trans('add')}
                type='button'
                onClick={() => addUser(fields)}
                disabled={!isEmailValide}
              />
            ) : null}
          </div>
          {error ? (
            <span className='text-error text-xs font-medium text-center mt-4 block'>
              {error}
            </span>
          ) : null}
          <div className='mt-24 space-y-24 my-40 overflow-auto min-h-0 custom-scrollbar'>
            {fields.map((name, index) => (
              <div className='flex items-center' key={`key_${name}`}>
                <div className='h-32 w-32 min-w-[32px] border-dashed border border-greyLight7 rounded-full' />
                <div className='ml-16'>
                  <span className='block text-greyLight3 text-sm font-medium'>
                    {values?.invitations?.[index]?.email ?? ''}
                  </span>
                  {values?.invitations?.[index]?.cant_invite || values?.invitations?.[index]?.wrong_status ? (
                    <span className='block mt-4 text-error text-xs leading-[15px]'>
                      {trans(
                        `users.invitation_check.${
                          values.invitations[index].cant_invite
                            ? 'already_an_administrator'
                            : 'already_part_of_agency'
                        }`
                      )}
                    </span>
                  ) : (
                    ''
                  )}
                </div>
                <div className='ml-auto'>
                  <Field name={`${name}.role`} component={RoleSelect} />
                </div>
                <button
                  type='button'
                  onClick={() => fields.remove(index)}
                  className='w-16 h-16 text-greyLight4 ml-24 block hover:text-error transition-colors'
                >
                  <i className='icon-close' />
                </button>
              </div>
            ))}
          </div>
          <SecondaryButton
            type='submit'
            disabled={!values?.invitations?.find((v) => !v.error) && !userEmail}
            text={
              values?.invitations?.length >= 2
                ? trans('users.buttons.validates')
                : trans('users.buttons.validate')
            }
            size='large'
            extraClass='w-full flex justify-center'
          />
        </div>
      )}
    </FieldArray>
  )
}

export default AddingUserForm
